import { render } from "./ContactEmail.vue?vue&type=template&id=6d632f37&scoped=true&ts=true"
import script from "./ContactEmail.vue?vue&type=script&lang=ts"
export * from "./ContactEmail.vue?vue&type=script&lang=ts"

import "./ContactEmail.vue?vue&type=style&index=0&id=6d632f37&scoped=true&lang=scss"

import exportComponent from "/home/vsts/work/1/s/src/CRM/OutlookAddin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6d632f37"]])

export default __exports__